<script setup lang="js">
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useSubmoduleStore } from '@/stores/submodule.store';
import ModalTemplateSide from '@/components/modals/ModalTemplateSide.vue';
import useModal from '@/stores/modal.store';

const submoduleStore = useSubmoduleStore();
const { closeModal } = useModal();

const { createSubmoduleGroupRequest } = storeToRefs(submoduleStore);

const name = ref(null);
const description = ref(null);

function createGroup() {
  submoduleStore.createSubmoduleGroup(name.value, description.value).then(() => {
    closeModal();
  });
}
function isErrorField(fieldName) {
  if (createSubmoduleGroupRequest.value.error?.errors) {
    return createSubmoduleGroupRequest.value.error.errors[fieldName] || false;
  }
}
function isNotFieldError() {
  if (!createSubmoduleGroupRequest.value.error?.errors) {
    return createSubmoduleGroupRequest.value.error;
  }
}
</script>

<template>
  <ModalTemplateSide @submit="createGroup" :disableButtons="createSubmoduleGroupRequest.isLoading">
    <template v-slot:title>Создать группу</template>
    <template v-slot:body>
      <div class="mt-3">
        <label class="form-label">Наименование</label>
        <input v-model="name" type="text" class="form-control" :class="{ error: isErrorField('name') }" />
        <p v-if="isErrorField('name')" class="error-mesage">
          <span v-for="error in isErrorField('name')">{{ error }}</span>
        </p>
      </div>
      <div class="mt-3">
        <label class="form-label">Описание</label>
        <textarea v-model="description" class="form-control" :class="{ error: isErrorField('description') }"></textarea>
        <p v-if="isErrorField('description')" class="error-mesage">
          <span v-for="error in isErrorField('description')">{{ error }}</span>
        </p>
      </div>
      <p v-if="isNotFieldError()" class="error-mesage">
        <span v-for="error in isNotFieldError()">{{ error }}</span>
      </p>
    </template>
    <template v-slot:submit>
      <img v-if="createSubmoduleGroupRequest.isLoading" class="loader" src="@/assets/img/loader.gif" alt="loader.gif" />
      <div v-else>Создать</div>
    </template>
  </ModalTemplateSide>
</template>
